import { UserConnectedLeader, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById<UserConnectedLeader>('userConnectedLeaders');
export const findByIdThrows = createFindByIdThrows<UserConnectedLeader>('userConnectedLeaders');

type GetFulfilledUserConnectedLeaders = (state: YammerState) => Record<string, UserConnectedLeader>;
export const getFulfilledUserConnectedLeaders: GetFulfilledUserConnectedLeaders = (state) =>
  state.userConnectedLeaders.fulfilled.byId;
